import { forwardRef } from 'react';
import { IconCheckRegular, IconLowestRegular } from '@croquiscom-pvt/zds';
import styled from '@emotion/styled';

import { Typography } from '@common/styles';
import { TouchAccessibilityWrapper } from '@domains/pdp-common';

interface CouponProps {
  buttonColor: string;
  isCouponAvailable: boolean;
  handleClickDownload: () => void;
}
export const Coupon = forwardRef<HTMLDivElement, CouponProps>(
  ({ buttonColor, isCouponAvailable, handleClickDownload }, ref) => {
    return (
      <TouchAccessibilityWrapper onClick={handleClickDownload} touchHeight={48}>
        <DownloadButton ref={ref} buttonColor={buttonColor} className={Typography.BODY_14_SEMIBOLD}>
          {isCouponAvailable ? (
            <>
              <IconLowestRegular size={20} style={{ color: buttonColor }} />
              <span>쿠폰 받기</span>
            </>
          ) : (
            <>
              <IconCheckRegular width={20} height={20} style={{ color: buttonColor }} />
              <span>받은 쿠폰</span>
            </>
          )}
        </DownloadButton>
      </TouchAccessibilityWrapper>
    );
  },
);

const DownloadButton = styled.div<{ buttonColor: string; width?: number }>`
  padding: 8px 18px 8px 14px;
  width: 106px;
  height: 38px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 22px;
  border: 1px solid ${({ buttonColor }) => buttonColor};
  color: ${({ buttonColor }) => buttonColor};
  cursor: pointer;
  white-space: nowrap;

  svg {
    margin: 0 2px 0 0;
  }

  span {
    position: relative;
    top: 1px;
  }
`;
